import React from "react";
import "./privacy_policy.css";

const PrivacyPolicy = () => {
  return (
    <main className="privacy-page">
      <div className="container">
        <h1>Privacy Policy – FanFaro India</h1>

        <p>
          We are delighted that you have shown interest in FanFaro India. Data protection is a high priority for our management. Using our website is possible without providing personal data. However, certain services may require processing personal data, for which we obtain consent when necessary.
        </p>

        <p>
          <strong>Definitions:</strong> Personal Data means information relating to an identified or identifiable person, e.g., name, email, or IP address. A Data Subject is any person whose personal data is processed by us. Processing is any operation on personal data such as collection, storage, or deletion. Consent is a freely given, specific, informed, and unambiguous agreement by the data subject.
        </p>

        <p>
          <strong>Controller Information:</strong> FanFaro India. <b>Address:</b>335,2rd cross street,JP nagar 8th Phase,Bengaluru 560076.Karnataka. <b>Phone:</b> [Your Phone Number]. <b>Email:</b> info@fanfaro.in. <b>Website:</b> www.fanfaro.in.
        </p>

        <p>
          <strong>Collection of General Data:</strong> When you visit our website, we collect general data such as browser type, operating system, date and time of access, IP address, and referring website. This helps us deliver content correctly, optimize our website, and ensure IT security. All data is analyzed anonymously.
        </p>

        <p>
          <strong>Registration and Personal Data:</strong> If you register on our website, personal data entered will be used internally only to provide services. Your IP address, date, and time of registration may be stored to prevent misuse. Personal data will not be shared with third parties unless legally required.
        </p>

        <p>
          <strong>Rights of Data Subjects:</strong> You have the right to access your data, correct inaccuracies, request deletion if processing is unnecessary, limit data processing, obtain your data in a structured, machine-readable format, and withdraw consent at any time.
        </p>

        <p>
          <strong>Third-Party Services:</strong> We may use third-party services like Google Analytics, YouTube, and Facebook plugins. These services may collect information such as page visits and IP addresses.
        </p>

        <p>
          <strong>Data Security:</strong> We implement technical and organizational measures to protect personal data. However, internet transmission may have security gaps, so absolute security cannot be guaranteed.
        </p>

        <p>
          <strong>Legal Basis:</strong> Personal data is processed in accordance with GDPR and Indian data protection laws. The legal basis depends on consent, contract fulfillment, legal obligations, vital interests, or legitimate interests.
        </p>

        <p>
          <strong>Contact:</strong> For any queries regarding your data or privacy rights, contact info@fanfaro.in.
        </p>

        <p className="privacy-footer">
          This privacy policy is adapted for FanFaro India based on FanFaro GmbH's original privacy declaration.
        </p>
      </div>
    </main>
  );
};

export default PrivacyPolicy;
